import React from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import { Message } from "../../interfaces";
interface Props {
  message: Message;
  type: string;
}

const ChatMessageTimestamp: React.FC<Props> = ({ message, type }) => {
  const { isManual, timestamp, status, svg, right } = message;
  return (
    <span className="chat-item-time">
      {isManual && type === "conversation" && (
        <span className="color-step-500">
          <FormattedMessage id="chats.manual" /> -{" "}
        </span>
      )}
      {type !== "debug" && <span className="color-step-500">{timestamp}</span>}
      {right && type === "conversation" && (
        <svg
          viewBox="0 0 16 11"
          height="11"
          width="16"
          preserveAspectRatio="xMidYMid meet"
          className={classNames("", {
            read: status === "read",
            failed: status === "failed",
          })}
          fill="none"
        >
          <path d={svg} fill="currentColor" />
        </svg>
      )}
    </span>
  );
};

export default ChatMessageTimestamp;
